module.exports = __webpack_public_path__ + "static/img/erwmgzh.3cba5fa5.png";